import * as tslib_1 from "tslib";
import { EventEmitter } from '@angular/core';
import { DOCUMENTS_TYPES } from '@bl-constants/docs-types.const';
export class HistoricalTableComponent {
    constructor(router, afsReviewService, startAnalysisService, stepperService, messageToastService, getAnalysisService, summaryReportService) {
        this.router = router;
        this.afsReviewService = afsReviewService;
        this.startAnalysisService = startAnalysisService;
        this.stepperService = stepperService;
        this.messageToastService = messageToastService;
        this.getAnalysisService = getAnalysisService;
        this.summaryReportService = summaryReportService;
        this.analysisRemoved = new EventEmitter();
        this.CURRENTSTEP = [
            { name: 'generateNewAnalysis', stepSelected: false, disabled: false },
            { name: 'icrReview', stepSelected: true, disabled: false },
        ];
        this.STEPINCOMPLETEANALYSIS = [
            { name: 'generateNewAnalysis', stepSelected: false },
            { name: 'afsReview', stepSelected: true },
            { name: 'score', stepSelected: false, disabled: true },
            { name: 'icrReview', stepSelected: false, disabled: false },
        ];
        this.STEPINCOMPLETEANALYSISNOICR = [
            { name: 'generateNewAnalysis', stepSelected: false },
            { name: 'afsReview', stepSelected: true },
            { name: 'score', stepSelected: false, disabled: true },
            { name: 'icrReview', stepSelected: false, disabled: true },
        ];
        this.STEPCOMPLETEANALYSISNOICR = [
            { name: 'generateNewAnalysis', stepSelected: false },
            { name: 'afsReview', stepSelected: false },
            { name: 'score', stepSelected: true },
            { name: 'icrReview', stepSelected: false, disabled: true },
        ];
        this.display = false;
        this.msgs = [];
        this._getAnalysisService = getAnalysisService;
    }
    redirectToAfsReview(data) {
        const stringData = JSON.stringify(data.analysisId);
        localStorage.setItem('analysisId', stringData);
        localStorage.setItem('analisisResultLocalStorage', JSON.stringify(data));
        localStorage.setItem('saveFindings', '[]');
        this.afsReviewService.setScore(true);
        this.checkStatusAnalysis(data.analysisId, data);
        this.startAnalysisService.setAnalysisData(data.analysisId);
    }
    removeAnalysis() {
        this.display = false;
        this.getAnalysisService.removeAnalysis(this.selectedForDelete.analysisId).subscribe(() => {
            this.analysisRemoved.emit(this.selectedForDelete);
            this.selectedForDelete = undefined;
            this.showToastSuccess('Analysis successfully removed', 'successMessageRemoved');
        }, () => {
            this.showToastError('An error was encountered when removing this analysis, please try again later', 'errorMessage-remove-analysis');
            this.selectedForDelete = undefined;
        });
    }
    downloadDocs(url, filename, type) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let ext = ".pdf";
            if (type == DOCUMENTS_TYPES.summary) {
                ext = ".docx";
            }
            if (url.indexOf('blob.core.windows') > 0) {
                yield this.summaryReportService.download(url, DOCUMENTS_TYPES[type]).toPromise()
                    .then(response => {
                    const blob = new Blob([response], { type: response.type });
                    const url = window.URL.createObjectURL(blob);
                    const anchorElement = document.createElement('a');
                    document.body.appendChild(anchorElement);
                    anchorElement.href = url;
                    anchorElement.download = filename + ext;
                    anchorElement.click();
                    window.URL.revokeObjectURL(url);
                }, (_error) => {
                });
            }
            else {
                window.open(url);
            }
        });
    }
    showConfirmationRemoveAnalysis(rowData) {
        this.selectedForDelete = rowData;
        this.display = true;
    }
    checkStatusAnalysis(analysisId, data) {
        this.getAnalysisService.getAnalysis(analysisId).subscribe((res) => {
            if (res) {
                this.analysisData = res;
                this.validateAnalisis = this.analysisData.testResults.filter((item) => item.answer_luca === 'Manual' && item.answerFms === '');
                if (this.validateAnalisis.length > 0) {
                    this.noFinishAnalysis(data);
                }
                else {
                    this.correctAnalysis(data);
                }
            }
        });
    }
    correctAnalysis(data) {
        this.router.navigate(['/score']);
        if (data && data.icr && data.icr.name) {
            this.stepperService.setStepper(this.CURRENTSTEP);
        }
        else {
            this.CURRENTSTEP[0].stepSelected = false;
            this.stepperService.setStepper(this.STEPCOMPLETEANALYSISNOICR);
        }
    }
    noFinishAnalysis(data) {
        this.router.navigate(['/AfsReview']);
        if (data && data.icr && data.icr.name) {
            this.stepperService.setStepper(this.STEPINCOMPLETEANALYSIS);
        }
        else {
            this.stepperService.setStepper(this.STEPINCOMPLETEANALYSISNOICR);
        }
    }
    showToastWarning(summary, detail) {
        this.messageToastService.showToastWarn('warn', summary, detail);
    }
    showToastError(summary, detail) {
        this.messageToastService.showToastError('error', summary, detail);
    }
    showToastSuccess(summary, detail) {
        this.messageToastService.showToastSuccess('Success', summary, detail);
    }
}
